import {
  appConfig,
  LanguageSelect,
  SoundManager,
  AnalyticsManager,
  PopupManager,
} from "@common";
import $ from 'jquery';
import * as PANOLENS from 'panolens';
import * as THREE from 'three';
import Loading from '../components/Loading';
import { assetDir } from '../config/paths';
import PanoramaController from '../panorama/PanoramaController';


const getFovsFromConfig = (config) => {
  const fovs = config.map(entry => entry.fov).filter((n => typeof n === 'number'));
  if (!fovs || fovs.length === 0) return {};
  const max = fovs.reduce((a, b) => Math.max(a, b));
  const min = fovs.reduce((a, b) => Math.min(a, b));
  return {  max: max, min: min };
};


class AppManager {
  constructor() {
    this.panoramaControllers = {};
    this.viewer = undefined;
    this.introViewRecord = {};
    this.initialCameraAngle = 0;
  }


  setMetaConfig(meta) {
    this.metaConfig = meta;
  }


  initLanguage() {
    LanguageSelect.addSelectElement();
    this.languageCode = LanguageSelect.detectLanguage();
    LanguageSelect.determineLanguage(this.languageCode);
    AnalyticsManager.sendLanguage(this.languageCode, 'initialDetect');
  }


  async preinit(panoramaConfig) {
    this.initLanguage();
    this.viewer = new PANOLENS.Viewer({
      controlBar: appConfig.debug.visiblePanoramaId,
      controlButtons: [],
      // viewIndicator: true,
      // indicatorSize: 100,
      // enableReticle: true, // trueにするとレティクルによる視点操作になる
      // autoReticleSelect: false,
      output: appConfig.debug.outputPosition ? 'console' : 'none',
      autoHideInfospot: false,
      // horizontalView: true,
      autoRotateSpeed: appConfig.autoRotateSpeed,
      suppressMomentum: true,
    });
    const fovs = getFovsFromConfig(panoramaConfig);
    this.viewer.OrbitControls.minFov = appConfig.minFov;
    this.viewer.OrbitControls.maxFov = fovs.max ? fovs.max : appConfig.maxFov;
    
    this.panoramaConfig = panoramaConfig;

    // 初期パノラマAdd
    const initialConf = this.panoramaConfig.find(conf => conf.id === appConfig.initialPanoramaId) || this.panoramaConfig[0];
    this.currentPanoramaController = new PanoramaController(this.viewer, initialConf, true);
    this.panoramaControllers[initialConf.id] = this.currentPanoramaController;
    await this.currentPanoramaController.load();
    this.currentPanoramaController.showAsWelcomeScreen();
  }


  init() {
    LanguageSelect.show();
    this.configWidget();
    this.createSiteLogo();
    this.createFloorNav();
    this.createHelpButton();
    this.createHomeButton();
    this.createMinimap();
    this.createCommentaryButton();
    this.createTaishiButton();
    this.createClickEffect();

    // 各パノラマ生成
    this.panoramaConfig.forEach(conf => {
      if (this.panoramaControllers[conf.id]) return;
      this.panoramaControllers[conf.id] = new PanoramaController(this.viewer, conf);
    });

    this.currentPanoramaController.startAsWelcomeScreen();
  }


  configWidget() {
    if (!appConfig.debug.visiblePanoramaId) return;
    // panorama name
    this.textWidget = this.viewer.appendControlItem({
      element: document.createElement('span'),
      style: {
        color: '#fff',
        width: 'auto',
        marginRight: '1em',
      },
    });
  }


  createSiteLogo() {
    const tag = `
<div id="site-logo">
  <a href="#" target="_blank"><img class="logo" src="${assetDir}/images/site_logo.png"></a>
</div>
    `;
    $('body').append(tag.trim());
    $('#site-logo a').on('click', event => {
      window.open(this.getSiteUrl());
      return false;
    });
  }


  createFloorNav(reset = false) {
    if (reset) {
      // 言語変更時に一旦削除して再作成
      $('#floor-nav').remove();
    }
    const tag = `
<div id="floor-nav">
  <button data-floor="present">
    <img class="active" src="${assetDir}/images/era/${this.currentLanguage}/age01_active.png">
    <img class="nonactive" src="${assetDir}/images/era/${this.currentLanguage}/age01_nonactive.png">
  </button>
  <button data-floor="modern">
    <img class="active" src="${assetDir}/images/era/${this.currentLanguage}/age02_active.png">
    <img class="nonactive" src="${assetDir}/images/era/${this.currentLanguage}/age02_nonactive.png">
  </button>
  <button data-floor="medieval">
    <img class="active" src="${assetDir}/images/era/${this.currentLanguage}/age03_active.png">
    <img class="nonactive" src="${assetDir}/images/era/${this.currentLanguage}/age03_nonactive.png">
  </button>
  <button data-floor="ancient">
    <img class="active" src="${assetDir}/images/era/${this.currentLanguage}/age04_active.png">
    <img class="nonactive" src="${assetDir}/images/era/${this.currentLanguage}/age04_nonactive.png">
  </button>
</div>
    `;
    $('body').append(tag.trim());
    $('#floor-nav button').on('click', event => {
      const floorTo = $(event.currentTarget).data('floor'); 
      if(this.currentFloor !== floorTo){
        const panoTo = this.getPanoramaById(appConfig.eraHome[floorTo]);
        if (panoTo) {
          this.gotoPanorama(panoTo);
        }
      }
    });
    if (reset) {
      // currentクラス付与
      this.setCurrentFloor(this.currentFloor, true);
    }
  }


  createHelpButton() {
    const tag = `
<div id="help-button">
  <button><img src="${assetDir}/images/buttons/help.png"></button>
</div>
    `;
    $('body').append(tag.trim());
    $('#help-button button').on('click', event => {
      PopupManager.openHelp();
    });
  }


  createHomeButton(reset = false) {
    if (reset) {
      $('#home-button button img').attr('src', `${assetDir}/images/buttons/${this.currentLanguage}/home.png`);
      return;
    }
    const tag = `
<div id="home-button">
  <button><img src="${assetDir}/images/buttons/${this.currentLanguage}/home.png"></button>
</div>
    `;
    $('body').append(tag.trim());
    $('#home-button button').on('click', event => {
      const panoTo = this.getPanoramaById(appConfig.eraHome[this.currentFloor]);
      if (panoTo) {
        this.gotoPanorama(panoTo);
      }
    });
  }


  createCommentaryButton(reset = false) {
    if (reset) {
      $('#commentary-button button img').attr('src', `${assetDir}/images/buttons/${this.currentLanguage}/commentary.png`);
      return;
    }
    const tag = `
<div id="commentary-button">
  <button><img src="${assetDir}/images/buttons/${this.currentLanguage}/commentary.png"></button>
</div>
    `;
    $('body').append(tag.trim());
    $('#commentary-button button').on('click', event => {
      const currentCtl = this.viewer.panorama.userData.controller;
      currentCtl.openCommentary();
    });
  }


  createTaishiButton(reset = false) {
    if (reset) {
      $('#taishi-button button img').attr('src', `${assetDir}/images/buttons/${this.currentLanguage}/taishi_road.png`);
      return;
    }
    const tag = `
<div id="taishi-button">
  <button><img src="${assetDir}/images/buttons/${this.currentLanguage}/taishi_road.png"></button>
</div>
    `;
    $('body').append(tag.trim());
    $('#taishi-button button').on('click', event => {
      this.gotoPanorama('33');
    });
  }


  createMinimap() {
    const tag = `
<div id="minimap">
  <img class="user" src="${assetDir}/images/minimap/user.png">
  <img class="map">
</div>
    `;
    $('body').append(tag.trim());
    const rotateElement = $('#minimap .map')[0];
    const updateMinimap = () => {
      if ($('#minimap').is(':visible')) {
        const angle = THREE.Math.radToDeg(this.viewer.camera.rotation.y);
        rotateElement.style.transform = `rotate(${this.initialCameraAngle + angle}deg)`;
      }
    };
    this.viewer.addUpdateCallback(updateMinimap);
    this.showMinimap(false);
  }


    gotoPanorama(panoTo) {           
    if (typeof panoTo === 'string') {
      panoTo = this.getPanoramaById(panoTo);
    }
    if (!panoTo) return; 

    if(panoTo.config.intro){
        panoTo.handleIntro();
        $('video')[0].addEventListener('ended', function() {  
          if (!panoTo.viewer.getScene().children.includes(panoTo)) {
            panoTo.viewer.add(panoTo.panorama);
          } 
          $.modal.close();
          panoTo.viewer.setPanorama(panoTo.panorama); 
        });    
    }else{ 
      const currentCtl = this.viewer.panorama.userData.controller;
      currentCtl.hideObject(); 
      if (!this.isPanoramaAdded(panoTo.panorama)) {
        this.viewer.add(panoTo.panorama);
      }    
      this.viewer.setPanorama(panoTo.panorama);
    }
  }

  isPanoramaAdded(pano) {
    const scene = this.viewer.getScene();
    return scene.children.includes(pano);
  }


  setCurrentFloor(floor, forceUpdate = false) {
    if (this.currentFloor === floor && !forceUpdate) return;
    const ref = $(`#floor-nav button[data-floor="${floor}"]`);
    if (!ref || ref.length == 0) return;
    $('#floor-nav .current').removeClass('current');
    ref.addClass('current');
    SoundManager.playBGM(floor);
    this.currentFloor = floor;
  }


  showEraButton(visible) {
    this.toggleFloorNav(visible);
  }


  showHomeButton(visible) {
    if (visible) $('#home-button').show();
    else $('#home-button').hide();
  }


  showCommentaryButton(visible) {
    if (visible) $('#commentary-button').show();
    else $('#commentary-button').hide();
  }


  showTaishiButton(visible) {
    if (visible) $('#taishi-button').show();
    else $('#taishi-button').hide();
  }


  showMinimap(visible, initAngle = 0) {
    this.initialCameraAngle = initAngle;
    if (this.currentFloor)
      $("#minimap img.map").attr(
        "src",
        `${assetDir}/images/minimap/map_${this.currentFloor}.png`
      );
    if (visible) $('#minimap').show();
    else $('#minimap').hide();
  }


  showInTextWidget(text) {
    if (this.textWidget) this.textWidget.textContent = text;
  }


  getPanoramaById(panoId) {
    return this.panoramaControllers[panoId];
  }


  toggleFloorNav(bool) {
    if (bool) {
      $('#floor-nav').show();
    } else {
      $('#floor-nav').hide();
    }
  }


  hasViewedIntro(panoId) {
    return this.introViewRecord[panoId] !== undefined;
  }


  markViewedIntro(panoId) {
    this.introViewRecord[panoId] = true;
  }


  onLanguageSelected(lang) {
    if (lang === this.currentLanguage) return false;
    this.languageCode = lang;
    this.viewer && this.viewer.dispatchEventToChildren({ type: 'change-language' });
    AnalyticsManager.sendLanguage(this.languageCode, 'userSelect');
    // 時代メニュー再作成
    this.createFloorNav(true);
    this.createHomeButton(true);
    this.createCommentaryButton(true);
    this.createTaishiButton(true);
    return true;
  }


  createClickEffect() {
    const tag = `<div id="click-effect"></div>`;
    this.clickEffect = $(tag.trim()).appendTo('body');
  }


  playClickEffect(event) {
    const fx = $('<div>', { class: 'fx' }).appendTo(this.clickEffect);
    this.clickEffect.css({
      top: event.pageY,
      left: event.pageX,
    });
    fx.delay(200).queue(function () {
      $(this).remove();
    });
  }


  setLoading(bool) {
    if (this.loading === undefined) this.loading = Loading.add();
    if (bool) this.loading.show();
    else this.loading.hide();
  }

  
  getSiteUrl() {
    const data = this.metaConfig.siteUrl;
    if (data && data[this.currentLanguage] && data[this.currentLanguage].length > 0) {
      return data[this.currentLanguage];
    }
    return data['en'];
  }


  convertToLocalizedPath(path) {
    if (path.indexOf('[lang]') < 0) return path;
    return path.replace('[lang]', this.currentLanguage);
  }


  getPopupConf(popupTo) {
    const [panoId, popupLabel] = popupTo.split('/');
    const panoConf = this.panoramaConfig.find(conf => {
            return conf.id === panoId;
    });
    if (!panoConf) return null;
    if (!panoConf.productView) return null;
    const popupConf = panoConf.productView.find(conf => {
        return conf.label === popupLabel;
    });
    return popupConf;
  }


  get isInitialized() {
    return this.viewer !== undefined;
  }


  get currentLanguage() {
    return this.languageCode;
  }


  get renderer() {
    return this.viewer.getRenderer();
  }

}

export default new AppManager();